<template>
  <div class="uk-container">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item>Options</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>Admin Options</h1>
    <vk-tabs>
      <vk-tabs-item title="Certifications">
        <div class="height">
          <input class="uk-input" type="text" v-model="newCertification">
          <vk-button type="primary">
            <vk-icon icon="plus" @click="postOption('certifications', newCertification)"></vk-icon>
          </vk-button>
          <ul class="uk-list uk-list-striped">
            <li
              v-for="(certification, index) in certifications"
              v-bind:key="'certifications' + index"
              class="uk-flex uk-flex-between"
            >
              <div>{{certification.certification}}</div>
              <a>
                <vk-icon icon="more-vertical" ratio="1" v-vk-tooltip.top="'More Actions'"></vk-icon>
              </a>
              <vk-drop mode="click" position="bottom-center">
                <vk-card>
                  <vk-icon
                    icon="minus-circle"
                    ratio="1"
                    @click="deleteOption('certifications', certification.id)"
                    v-vk-tooltip.bottom="'Delete'"
                  ></vk-icon>
                </vk-card>
              </vk-drop>
            </li>
          </ul>
        </div>
      </vk-tabs-item>
      <vk-tabs-item title="Classifications">
        <div class="height">
          <input class="uk-input" type="text" v-model="newClassification">
          <vk-button type="primary">
            <vk-icon icon="plus" @click="postOption('classifications', newClassification)"></vk-icon>
          </vk-button>
          <ul class="uk-list uk-list-striped">
            <li
              v-for="(classification, index) in classifications"
              v-bind:key="'classifications' + index"
              class="uk-flex uk-flex-between"
            >
              <div>{{classification.classification}}</div>
              <a>
                <vk-icon icon="more-vertical" ratio="1" v-vk-tooltip.top="'More Actions'"></vk-icon>
              </a>
              <vk-drop mode="click" position="bottom-center">
                <vk-card>
                  <vk-icon
                    icon="minus-circle"
                    ratio="1"
                    @click="deleteOption('classifications', classification.id)"
                    v-vk-tooltip.bottom="'Delete'"
                  ></vk-icon>
                </vk-card>
              </vk-drop>
            </li>
          </ul>
        </div>
      </vk-tabs-item>
    </vk-tabs>
  </div>
</template>

<script>
import OptionsApi from "@/utils/api/options";

export default {
  name: "DashboardOptions",
  data() {
    return {
      certifications: null,
      classifications: null,
      newCertification: "",
      newClassification: ""
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      OptionsApi.getAllOptions(this.$cookie.get("iwl_apiToken"))
        .then(res => {
          this.certifications = res.certifications;
          this.classifications = res.classifications;
          this.newCertification = "";
          this.newClassification = "";
        })
        .catch(err => console.log(err));
    },
    postOption(category, option) {
      if (option != "") {
        OptionsApi.postOption(
          this.$cookie.get("iwl_apiToken"),
          category,
          option
        )
          .then(res => this.refresh())
          .catch(err => console.log(err));
      }
    },
    deleteOption(category, id) {
      OptionsApi.deleteOption(this.$cookie.get("iwl_apiToken"), category, id)
        .then(res => this.refresh())
        .catch(err => console.log(err));
    }
  }
};
</script>

<style scoped>
h1 {
  margin-bottom: 50px;
}
.uk-badge {
  height: 24px;
  margin-right: 5px;
  cursor: pointer;
  background: #f0506e;
}
.uk-badge:hover {
  background: #ee395b;
}
input[type="text"] {
  width: 200px;
}
.height {
  min-height: 300px;
}
ul li:before,
ul li:after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_dashboard_options.vue